var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCloseWhisperPopup(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCloseWhisperPopup") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.42618223,6.00002817 L11.7046233,1.72158211 C12.0984589,1.32774601 12.0984589,0.689213173 11.7046233,0.295433417 C11.3107876,-0.0984026819 10.6723119,-0.0984026819 10.2784763,0.295433417 L5.99997887,4.57393583 L1.72148148,0.295377074 C1.32764585,-0.0984590247 0.689170107,-0.0984590247 0.29533447,0.295377074 C-0.0984448235,0.689213173 -0.0984448235,1.32774601 0.29533447,1.72152576 L4.57383186,5.99997183 L0.29533447,10.2784742 C-0.0984448235,10.6723103 -0.0984448235,11.3108432 0.29533447,11.7046229 C0.689170107,12.098459 1.32764585,12.098459 1.72148148,11.7046229 L5.99997887,7.42612052 L10.2784763,11.7046229 C10.6722556,12.098459 11.3107876,12.098459 11.7046233,11.7046229 C12.0984589,11.3107868 12.0984589,10.6723103 11.7046233,10.2784742 L7.42618223,6.00002817 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DESKTOP-CHAT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chatrooms---whisper",
    transform: "translate(-373.000000, -914.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(95.000000, 904.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/General/Cross",
    transform: "translate(278.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icCloseWhisperPopup",
    fill: "#333333",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseWhisperPopup);
export default __webpack_public_path__ + "static/media/icCloseWhisperPopup.a0efd1da0af9a64dc90e67197976db3f.svg";
export { ForwardRef as ReactComponent };